import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useState, useEffect } from 'react';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import Currency from 'Components/Format/Currency';
import Percentage from 'Components/Format/Percentage';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import './index.css';

const Taxes = () => {
  const { getTaxInfoByHouseholdId } = useSwaggerlessContext();
  const [taxData, setTaxData] = useState({
    attributes: {
      adjustedGrossIncome: null,
      carryoverLoss: null,
      refundOrShortfall: null,
      itemizedDeductions: null,
      estimatedPayment: null,
      marginalTaxBracket: null,
      longTermCapitalGains: null,
      effectiveRate: null,
      altMinTax: null,
    },
  });
  const { householdId } = useSimpleHousehold();

  useEffect(() => {
    if (householdId > 0) {
      getTaxInfoByHouseholdId(householdId).then((res) => {
        if (res?.data) {
          setTaxData(res.data);
        }
      });
    }
  }, [householdId]);

  const {
    adjustedGrossIncome,
    carryoverLoss,
    refundOrShortfall,
    itemizedDeductions,
    estimatedPayment,
    marginalTaxBracket,
    longTermCapitalGains,
    effectiveRate,
    altMinTax,
  } = taxData.attributes;
  return (
    <div className="taxes">
      <div className="content">
        <div className="table-row">
          <div className="row-name">Adj. Gross Income</div>
          <div className="row-value">
            <Currency amount={adjustedGrossIncome || 0} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Carryover Loss</div>
          <div className="row-value">
            <Currency amount={carryoverLoss || 0} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Refund/Shortfall</div>
          <div className="row-value">
            <Currency amount={refundOrShortfall || 0} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Itemized Deductions</div>
          <div className="row-value">
            {itemizedDeductions ? (
              <Currency amount={itemizedDeductions} />
            ) : (
              <FontAwesome icon="times-circle" />
            )}
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Est. Quarterly</div>
          <div className="row-value">
            {estimatedPayment ? (
              <Currency amount={estimatedPayment} />
            ) : (
              <FontAwesome icon="times-circle" />
            )}
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Marginal Bracket</div>
          <div className="row-value">
            <Percentage amount={marginalTaxBracket / 100} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">LT Capital Gains</div>
          <div className="row-value">
            <Percentage amount={longTermCapitalGains / 100} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Effective Rate</div>
          <div className="row-value">
            <Percentage amount={effectiveRate / 100} />
          </div>
        </div>
        <div className="table-row">
          <div className="row-name">Alt. Min Tax</div>
          <div className="row-value">
            {altMinTax ? (
              <FontAwesome icon="check-circle" />
            ) : (
              <FontAwesome icon="times-circle" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Taxes.propTypes = {
};

export default Taxes;
